import { useAuth } from "../contexts/AuthContext"
import { axiosPrivate } from "../services/makeRequest"
import { jwtDecode } from "jwt-decode"
import { useMutation } from "@tanstack/react-query"

function getRefreshToken() {
    return axiosPrivate("/refresh", {
        method: "GET",
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? "Error")
        })
}

const useRefreshToken = () => {
    const { setAuth, setAuthError } = useAuth()

    const mutation = useMutation({
        mutationKey: ["refreshToken"],
        mutationFn: async () => {
            const response = await getRefreshToken()
            const { firstName, lastName } = jwtDecode(response.accessToken)
            setAuth((prev) => ({
                ...prev,
                firstName: firstName,
                lastName: lastName,
                token: response.accessToken,
            }))
            return response.accessToken
        },
        onError: (error) => {
            setAuthError(error)
            // Do NOT navigate here
        },
    })

    return mutation
}

export default useRefreshToken
